import React from 'react';
import classnames from 'classnames';
import styles from './timeslot-selection.module.scss';

export type TimeBubbleProps = {
  timeWindow: string;
  selected: boolean;
  className?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;

  // labelId: the headline of the whole date-&time-picker
  // dateId: the day for which you're selecting a time slot.
  // Both are needed so that a screenreader can read the whole context: "12:00 - 15:00" and then "Select a test drive date. 23.11.2022"
  labelId?: string;
  dateId?: string;
};

const TimeBubble: React.FC<TimeBubbleProps> = ({ timeWindow, selected, className, onClick, labelId, dateId }) => (
  <button
    aria-pressed={selected}
    aria-describedby={`${labelId} ${dateId}`}
    className={(classnames(styles.timebubble, { [styles[`timebubble--selected`]]: selected }), className)}
    onClick={onClick}
  >
    {timeWindow}
  </button>
);

export type TimeSlotSelectionProps = {
  timeSlots: TimeBubbleProps[];
  className?: string;
};

export const TimeSlotSelection: React.FC<TimeSlotSelectionProps> = ({ timeSlots, className }) => {
  const classes = classnames(styles.timeslotSelection, className);

  return (
    <div className={classes} data-testid="timeslotselection-component">
      {timeSlots.map((timeSlot, i) => (
        <TimeBubble
          key={`${timeSlot.timeWindow}-${i}-control`}
          {...timeSlot}
          className={classnames(styles.timebubble, {
            [styles[`timebubble--selected`]]: timeSlot.selected
          })}
        />
      ))}
    </div>
  );
};
TimeSlotSelection.displayName = 'TimeSlotSelection';
